import React, {Component} from 'react'
import PropTypes from 'prop-types'
import SEO from 'components/seo'
// import CookieConsent from "react-cookie-consent"
import { useLocation } from '@reach/router'
import {window} from 'browser-monads'
import '../../stylesheets/main.scss'

const scrollToElement = require('scroll-to-element')

class Layout extends Component {
    constructor(props) {
        super(props)

        this.state = {
            // siteversion: 'V8',
            siteversion: 'V10',
            // siteversion: 'V6',
            // siteversion: 'V12',
            // siteversion: 'V15',
        }
    }

    componentDidMount() {
        scrollToElement('html')

        const defaultSiteVersionSet = true;

        // Is the siteversion identified on url?
        let siteversionQueryString = null
        const urlParams = new URLSearchParams(window.location.search);
        siteversionQueryString = urlParams.get('v');

        // if query exists skip lotame
        if (siteversionQueryString !== null) {
            this.setSiteVersion(null, siteversionQueryString)
        } else {
            // if default site version is set, skip Lotame
            if (!defaultSiteVersionSet) {
                // Use lotame as no query string
                if (typeof window.lotame !== 'undefined') {
                    this.setSiteVersion(window.lotame.Profile.Audiences.Audience)
                }
            }

            // This is for testing purposes, needs to be deleted
            if (typeof window.lotame !== 'undefined') {
                Object.keys(window.lotame.Profile.Audiences.Audience).map(key => {
                    console.log(window.lotame.Profile.Audiences.Audience[key]['abbr']);
                })
            }
        }
    }

    setSiteVersion = (audiences, siteversionQueryString = null) => {

        let siteversion = ''
        let abbr = ''

        // Might be best to eventually query tickx.json
        const siteVersions = [
            'V13',
            // 'V12',
            'V10',
            'V8',
            // 'V6S',
            // 'V6L'
        ]

        // change siteversion based on querystring or lotame
        if (siteversionQueryString !== null) {
            abbr = siteversionQueryString.toUpperCase();
            if (siteVersions.indexOf(abbr) > -1) {
                siteversion = abbr
            }
        } else {
            Object.keys(audiences).map(key => {
                abbr = audiences[key]['abbr'].toUpperCase();
                if (siteVersions.indexOf(abbr) > -1) {
                    siteversion = abbr
                }
            });
        }

        // check if we have a siteversion
        if (siteversion !== '') {
            this.setState({
                siteversion: siteversion
            });
        }
    };

    capitalizeFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1)
    }

    render() {
        const {title, description, path, language, languageCode} = this.props.data
        let siteName

        if (this.props.data.siteId === '' || !this.props.data.siteId) {
            siteName = false
        } else {
            siteName = this.capitalizeFirstLetter(this.props.data.siteId)
        }

        const metaTitle =
            this.props.data.metaTitle || title

        const metaDescription =
            this.props.data.metaDescription || description

        const {children} = this.props;

        const siteversion = this.state.siteversion;

        /**
         **********************************************
         **/

        /**
         * HACK: This is how you pass params to child
         **/
        const childrenWithProps = React.Children.map(children, child =>
            React.cloneElement(child, {siteversion, languageCode})
        );

        console.log("siteversion:", this.state.siteversion)
        const schema = {
            '@context': 'https://schema.org',
            "@type": "TheaterGroup",
            name: `${metaTitle}`,
            "alternateName": "The Book Of Mormon Musical",
            description: `${metaDescription}`,
            url: `'https://thebookofmormonmusical.com/`,
            "logo": "https://thebookofmormonmusical.com/quantcast-image.jpg",
            "sameAs": [
                "https://www.facebook.com/bookofmormonUK/",
                "https://twitter.com/bookofmormonuk",
                "https://www.instagram.com/bookofmormonuk/",
                "https://www.youtube.com/channel/UCQfNJ5Mxr8zC7lHgMDwkheA"
              ]
          }
          console.log(schema)

        return (
            <>
                {/*<CookieConsent*/}
                {/*    location="bottom"*/}
                {/*    disableStyles={true}*/}
                {/*    buttonText="Accept Cookies and Close"*/}
                {/*    cookieName="bcookie"*/}
                {/*    containerClasses="cookie"*/}
                {/*    contentClasses="cookieContent"*/}
                {/*    buttonClasses="btn btn--yellow"*/}
                {/*    expires={150}*/}
                {/*>*/}
                {/*    <Container>*/}
                {/*        <p><strong>COOKIE CONSENT REQUEST</strong></p>*/}
                {/*        <p>We use cookies to help make our website and advertising better. For more information on cookies, how we use them and how to opt out please see our <Link*/}
                {/*            className="link" to="/cookie-privacy">cookies page.</Link> Otherwise, we’ll assume you’re OK to continue.</p>*/}
                {/*    </Container>*/}
                {/*</CookieConsent>*/}
                <SEO
                    title={metaTitle}
                    siteName={siteName}
                    description={metaDescription}
                    lang={language}
                    languageCode={languageCode}
                    path={path}
                    keywords={[`The Book Of Mormon`]}
                    schemaMarkup={schema}
                />
                <div className={`wrapper ${this.props.data.template}`}>
                {childrenWithProps}
                </div>
            </>
        )
    }
}

Layout.propTypes = {
    children: PropTypes.node.isRequired,
}

Layout.defaultProps = {
    data: {
        title: '',
        description: 'The Book of Mormon, The hit musical by Matt Stone and Trey Parker, creators of South Park and Bobby Lopez (Avenue Q, Frozen). God\'s favourite musical',
        siteName: true,
        languageCode: 'en-GB'
    },
    displayHeader: true,
    displayFooter: true,
    displayFooterFindOutMore: false
};

export default Layout
